import { useEffect, useState } from "react";
import { DEFAULT_GATEWAY_EN, DEFAULT_GATEWAY_FR } from "../../../const/const";

import { useFetch } from "./useFetch";

const useFetchHotelOptions = lang => {
	const [data, setData] = useState([]);

	const [processing, _fetchData] = useFetch();
	const fetchData = (gateway, dest) => {
		_fetchData(
			`${
				process.env.GATSBY_LPC_API_BASE_URL
			}SV/search/SVHotelList/?brand=swg&lang=${lang}&gateway=${gateway}&destinationid=${dest.replaceAll(
				",",
				"_"
			)}`
		)
			.then(result => {
				setData(
					result?.[0]?.hotels?.map(i => {
						const j = i.split("--xx--");
						return { value: j[1], label: j[0] };
					})
				);
			})
			.catch(() => {
				setData([]);
			});
	};
	useEffect(() => {
		fetchData(
			lang === "fr" ? DEFAULT_GATEWAY_FR : DEFAULT_GATEWAY_EN,
			lang === "er"
				? process.env.GATSBY_LPC_DEFAULT_DESTINATION_FR
				: process.env.GATSBY_LPC_DEFAULT_DESTINATION_EN
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return [data, processing, fetchData];
};

export default useFetchHotelOptions;
export { useFetchHotelOptions };
